import React from "react";
import { Navigate, useLocation } from "react-router-dom";

// HOC-компонент для защиты роутов
export default function RequireAuth({ children }) {
  const token = localStorage.getItem("token");
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}
